const ServiceTypes = {
  Staging: 'Staging',
  Mortgages: 'Mortgages',
  Photography: 'Photography',
  Measurements: 'Measurements',
  Legal: 'Legal',
  HomeInspection: 'Home Inspection',
};

export default ServiceTypes;
